import { useState } from "react"

import { useDebounce } from "shared/lib/performance/useDebounce"

import { PortalNewsFilterFormData } from "entities/portal-news/types/PortalNewsFilter"
import { useScrivitoPortalNewsListModel } from "widgets/portal-news-list/model/useScrivitoPortalNewsListModel"

import { PortalNewsPageProps } from "../PortalNewsPage"
import { PortalNewsPageModel } from "../PortalNewsPageConnector"

export function usePortalNewsPageModel({
  page
}: PortalNewsPageModel): PortalNewsPageProps {
  const [filterState, setFilterState] = useState<PortalNewsFilterFormData>({
    searchTerm: null
  })

  const debouncedSearchTerm = useDebounce(filterState.searchTerm, 400)

  const portalNewsListModel = useScrivitoPortalNewsListModel({
    page,
    searchTerm: debouncedSearchTerm
  })

  return {
    filterState,
    page,
    portalNewsListModel,
    setFilterState
  }
}
